@if (selectedBluePrintNode) {
<div class="div-right-panel-component">
  <form #myForm="ngForm">
    <fieldset [disabled]="isReadOnly" style="border: none; padding: 0; margin: 0">
      <mat-form-field>
        <mat-label>Name</mat-label>
        <input matInput maxlength="255" #inputName required (focus)="selectName()" type="text"
          [(ngModel)]="selectedBluePrintNode.name" name="name" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Description</mat-label>
        <textarea matInput [(ngModel)]="selectedBluePrintNode.description" name="description"></textarea>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Order</mat-label>
        <input matInput required maxlength="2" type="number" [(ngModel)]="selectedBluePrintNode.order" name="order" />
      </mat-form-field>
      <!--Power Node type is complext mechanism which we are not using, so commented out, we will relook at it later-->
      <!-- <mat-form-field>
        <mat-label>Node Type</mat-label>
        <mat-select name="nodeType" [(ngModel)]="selectedBluePrintNode.powerNodeType" (ngModelChange)="nodeTypeChange($event)" required>
          @for (powerNode of powerNodeList; track powerNode) {
          <mat-option [value]="powerNode.value">
            {{ powerNode.text }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field> -->
      <mat-form-field>
        <mat-label>Label</mat-label>
        <input matInput maxlength="255" type="text" [(ngModel)]="selectedBluePrintNode.label" name="label" />
      </mat-form-field>
      <div style="display: flex; flex-direction: column; gap: 4px">
        <!-- Background Colour -->
        <div style="display: flex; align-items: center; gap: 12px">
          <span style="min-width: 130px; font-size: 14px">Background Colour</span>
          <input [(colorPicker)]="color" [style.background]="selectedBluePrintNode.backgroundColor" name="nodecolor"
            [cpPosition]="'bottom'" [cpPositionRelativeToArrow]="true"
            (colorPickerChange)="selectedBluePrintNode.backgroundColor = $event; !isReadOnly && (formChanged = true)"
            style="width: 32px; height: 32px; flex-shrink: 0; border: 2px solid #ccc; cursor: pointer" />
          <mat-form-field style="flex: 1">
            <mat-label>Hex</mat-label>
            <input matInput type="text" [(ngModel)]="selectedBluePrintNode.backgroundColor" name="backgroundcolorhex" />
          </mat-form-field>
        </div>
        <!-- Text Colour -->
        <div style="display: flex; align-items: center; gap: 12px">
          <span style="min-width: 130px; font-size: 14px">Text Colour</span>
          <input [(colorPicker)]="color" [style.background]="selectedBluePrintNode.textColor" name="textColor"
            [cpPosition]="'bottom'" [cpPositionRelativeToArrow]="true"
            (colorPickerChange)="selectedBluePrintNode.textColor = $event; !isReadOnly && (formChanged = true)"
            style="width: 32px; height: 32px; flex-shrink: 0; border: 2px solid #ccc; cursor: pointer" />
          <mat-form-field style="flex: 1">
            <mat-label>Hex</mat-label>
            <input matInput type="text" [(ngModel)]="selectedBluePrintNode.textColor" name="textcolorhex" />
          </mat-form-field>
        </div>
        <!-- Border Colour -->
        <div style="display: flex; align-items: center; gap: 12px">
          <span style="min-width: 130px; font-size: 14px">Border Colour</span>
          <input [(colorPicker)]="color" [style.background]="selectedBluePrintNode.borderColor" name="borderColor"
            [cpPosition]="'bottom'" [cpPositionRelativeToArrow]="true"
            (colorPickerChange)="selectedBluePrintNode.borderColor = $event; !isReadOnly && (formChanged = true)"
            style="width: 32px; height: 32px; flex-shrink: 0; border: 2px solid #ccc; cursor: pointer" />
          <mat-form-field style="flex: 1">
            <mat-label>Hex</mat-label>
            <input matInput type="text" [(ngModel)]="selectedBluePrintNode.borderColor" name="bordercolorhex" />
          </mat-form-field>
        </div>
      </div>
      <mat-form-field>
        <mat-label>Border Thickness (0–5)</mat-label>
        <input matInput type="number" min="0" max="5" [(ngModel)]="selectedBluePrintNode.borderThickness"
          name="borderThickness" />
      </mat-form-field>
      <!-- dropdown -->
      <mat-form-field>
        <mat-label>Item Shape</mat-label>
        <mat-select [(ngModel)]="selectedBluePrintNode.nodeShape" name="nodeShape">
          @for (item of nodeShapeList; track item) {
          <mat-option [value]="item">
            {{ item }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Tooltip</mat-label>
        <textarea matInput maxlength="500" [(ngModel)]="selectedBluePrintNode.tooltip" name="tooltip"></textarea>
      </mat-form-field>
      <div style="padding-bottom: 20px">
        <app-blueprint--field-allocation name="fieldAllocationTable" [inputTableData]="fieldAllocationInputTableData"
          [inputTableConfig]="fieldAllocationTableConfig" [isReadOnly]="isReadOnly"
          (outputTableDataEvent)="onGetFieldAllocationTableDataOutput($event)"></app-blueprint--field-allocation>
      </div>
      <div>
        <!-- <app-blueprint-property-binding-table
          name="propertBindingTable"
          [inputTableData]="propertyBindingInputTableData"
          [inputTableConfig]="propertyBindingTableConfig"
          [isReadOnly]="isReadOnly"
          (outputTableDataEvent)="onGetPropertyBindingTableDataOutput($event)"></app-blueprint-property-binding-table> -->
      </div>
    </fieldset>
    <div class="save-button-div" *ngIf="!isReadOnly">
      <button mat-raised-button color="primary" (click)="saveWork()"
        [disabled]="!myForm.form.valid || (!myForm.form.dirty && !formChanged)">Save</button>
    </div>
  </form>
</div>
}